import { ThemeOptions } from '@mui/material';
import type {} from '@mui/lab/themeAugmentation';

import { palette } from './palette';

export const themeOptions: ThemeOptions = {
  palette,
  spacing: 8,
};
